export function UserDetails() {
    return <h1>Hello from UserDetails</h1>
}